import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import HolisticSection from 'common/Print/components/HolisticSection/HolisticSection.component';
import HolisticStats from 'common/Print/components/HolisticStats/HolisticStats.component';
import { startCase } from 'lodash';
var HolisticAssessmentTemplate = function (props) {
    var _a = props.data, data = _a === void 0 ? [] : _a;
    return (_jsxs(Box, { "data-testid": 'holistic-template', children: [data === null || data === void 0 ? void 0 : data.map(function (section) { return (_jsx(HolisticSection, { heading: startCase(section.surveyName), data: section.surveyData }, section.surveyName)); }), _jsx(HolisticStats, { data: data })] }));
};
export default HolisticAssessmentTemplate;
